export default "__VITE_ASSET__LTQP_xJV__"